/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * File field representation.
 */
export interface FileClaimValue {
    /** The file field value. */
    value: Truvity.CredentialClaimLinkedFileValue;
}
